// What changed, newest first — and the ONE place the app's version lives.
//
// APP_VERSION is read off the first entry, so the number on screen and the
// number in the history cannot disagree. To release: add an entry at the TOP,
// and bump "version" in api/package.json to match (the server reports its own).
//
// Write for the people who USE the app, not the people who build it: what they
// can now do, not which file changed. Each text is written in all three
// languages; a missing one falls back to English.
//
// The version numbers before 1.7.0 were assigned in hindsight, from the dates
// each group of work shipped — there was no versioning before this page.
//
// type: 'new' | 'improved' | 'fixed'
export const CHANGELOG = [
  {
    version: '1.8.9',
    date: '2026-10-25',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Packing list: the sheet of short labels now uses the whole page. The labels are taller and evenly spaced, so five of them fill an A4 sheet instead of stopping two-thirds of the way down, and the text on them is heavier and easier to read.',
          ar: 'قائمة التعبئة: صارت ورقة الملصقات القصيرة تستخدم الصفحة كلها. الملصقات أطول ومتباعدة بالتساوي، فتملأ خمسة منها ورقة A4 بدل أن تتوقف عند ثلثيها، والنص عليها أثقل وأسهل قراءة.',
          fa: 'پکینگ لیست: برگهٔ لیبل‌های کوتاه حالا کل صفحه را پر می‌کند. لیبل‌ها بلندتر و با فاصلهٔ یکسان‌اند، پس پنج لیبل یک برگ A4 را پر می‌کنند و در دو سومِ آن متوقف نمی‌شوند، و نوشتهٔ روی آن‌ها پررنگ‌تر و خواناتر است.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: the large pallet label no longer shows the loading origin. It shows the destination only; the origin is still on the packing list itself.',
          ar: 'قائمة التعبئة: لم يعد ملصق الطبلية الكبير يعرض مبدأ الشحن. يعرض الوجهة فقط، ويبقى المبدأ ظاهرًا في قائمة التعبئة نفسها.',
          fa: 'پکینگ لیست: لیبل بزرگ پالت دیگر مبدأ بارگیری را نشان نمی‌دهد و فقط مقصد را می‌نویسد؛ مبدأ همچنان روی خود پکینگ لیست چاپ می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.8',
    date: '2026-10-25',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Packing list: the loading origin and the final destination are now picked from a list your branch builds up. If the place you need is not there, type it and press Enter to add it — it is in the list from then on. Pressing Enter on the field before opens the origin list, the arrow keys walk it, and Enter picks a place and moves straight on to the destination list.',
          ar: 'قائمة التعبئة: صار مبدأ الشحن والوجهة النهائية يُختاران من قائمة يبنيها فرعك. وإن لم يكن المكان المطلوب موجودًا، اكتبه واضغط Enter لإضافته فيبقى في القائمة بعدها. والضغط على Enter في الحقل السابق يفتح قائمة المبدأ، وتتنقل بين الأماكن بالأسهم، ويختار Enter المكان وينتقل مباشرة إلى قائمة الوجهة.',
          fa: 'پکینگ لیست: مبدأ بارگیری و مقصد نهایی حالا از لیستی انتخاب می‌شوند که شعبهٔ خودتان می‌سازد. اگر مکان مورد نظر در لیست نبود، آن را بنویسید و Enter بزنید تا اضافه شود و از آن پس در لیست بماند. زدن Enter در فیلد قبلی لیست مبدأ را باز می‌کند، با کلیدهای جهت‌نما بین مکان‌ها حرکت می‌کنید و Enter مکان را انتخاب می‌کند و مستقیم به لیست مقصد می‌رود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list: every row of a pallet now has a Sort (Q, S or W), chosen from a list. Enter opens the list, the arrow keys walk it, and Enter picks one and moves on to the next cell. It prints on the packing list beside the stone code.',
          ar: 'قائمة التعبئة: صار لكل صف في الطبلية تصنيف (Q أو S أو W) يُختار من قائمة. يفتح Enter القائمة، وتتنقل فيها بالأسهم، ويختار Enter عنصرًا وينتقل إلى الخلية التالية. ويُطبع على قائمة التعبئة بجانب رمز الحجر.',
          fa: 'پکینگ لیست: هر ردیف از پالت حالا یک سورت (Q، S یا W) دارد که از یک لیست انتخاب می‌شود. Enter لیست را باز می‌کند، با کلیدهای جهت‌نما در آن حرکت می‌کنید و Enter یکی را انتخاب می‌کند و به خانهٔ بعد می‌رود. سورت کنار شناسه سنگ روی پکینگ لیست چاپ می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: a pallet can be filled without leaving the keyboard. Insert adds a pallet and puts the cursor in it, and Enter on the last cell of a row inserts a new row right after it and puts the cursor in its stone code. Removing a place from the origin or destination list now asks you to confirm first.',
          ar: 'قائمة التعبئة: يمكن ملء الطبلية دون مغادرة لوحة المفاتيح. فمفتاح Insert يضيف طبلية ويضع المؤشر فيها، و Enter في آخر خلية من الصف يُدرج صفًا جديدًا بعده مباشرة ويضع المؤشر في رمز حجره. وصار حذف مكان من قائمة المبدأ أو الوجهة يطلب منك التأكيد أولًا.',
          fa: 'پکینگ لیست: یک پالت را می‌شود بدون ترک صفحه‌کلید پر کرد. کلید Insert یک پالت اضافه می‌کند و مکان‌نما را در آن می‌گذارد، و Enter روی آخرین خانهٔ یک ردیف، یک ردیف جدید درست بعد از آن می‌سازد و مکان‌نما را در شناسه سنگ آن می‌گذارد. حذف یک مکان از لیست مبدأ یا مقصد هم حالا اول تأیید می‌گیرد.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list: the names on the form follow what people call these things — a pallet\u2019s “Reference” is now its “Pallet code”, and a row\u2019s “Code” is its “Stone code”. The driver\u2019s national ID and smart number are one field, and the driver\u2019s bank IBAN and the phone numbers of the loading officer and the customs agent are no longer asked for. A list saved before this keeps everything it was saved with.',
          ar: 'قائمة التعبئة: صارت التسميات في النموذج كما يسمّيها الناس — فمرجع الطبلية صار «رمز الطبلية»، ورمز الصف صار «رمز الحجر». ودُمج الرقم الوطني للسائق مع رقمه الذكي في حقل واحد، ولم يعد يُطلب آيبان السائق ولا هاتف مسؤول التحميل ولا هاتف مندوب التخليص. وتحتفظ أي قائمة محفوظة قبل ذلك بكل ما حُفظ فيها.',
          fa: 'پکینگ لیست: نام فیلدهای فرم همان چیزی شد که مردم می‌گویند — «رفرنس» پالت حالا «کد پالت» است و «کد» هر ردیف «شناسه سنگ». کد ملی و شماره هوشمند راننده یک فیلد شدند، و شماره شبای راننده و شماره تلفن مسئول بارگیری و نمایندهٔ گمرک دیگر پرسیده نمی‌شوند. لیستی که پیش از این ذخیره شده، هر چه داشته نگه می‌دارد.',
        },
      },
    ],
  },
  {
    version: '1.8.7',
    date: '2026-10-24',
    changes: [
      {
        type: 'fixed',
        text: {
          en: 'Downloaded files now keep their format. A file you download from Files, from Raw Contents, or from any viewer or gallery in the app arrives with its proper extension (for example "Front view.jpg" instead of just "Front view"), so your computer knows what it is and opens it with the right program. Files inside a zip download are named the same way.',
          ar: 'الملفات المُنزَّلة تحتفظ الآن بصيغتها. فالملف الذي تنزّله من الملفات أو من المحتوى الخام أو من أي عارض أو معرض في التطبيق يصل بامتداده الصحيح (مثلاً «Front view.jpg» بدل «Front view» فقط)، فيعرف جهازك نوعه ويفتحه بالبرنامج المناسب. وتُسمّى الملفات داخل التنزيل المضغوط بالطريقة نفسها.',
          fa: 'فایل‌های دانلودشده اکنون فرمت خود را نگه می‌دارند. فایلی که از فایل‌ها، محتوای خام یا هر نمایشگر و گالری برنامه دانلود کنید با پسوند درستش می‌رسد (مثلاً «Front view.jpg» به‌جای «Front view» تنها)، پس سیستم شما نوع آن را می‌شناسد و با برنامهٔ مناسب بازش می‌کند. فایل‌های داخل دانلود فشرده هم همین‌طور نام‌گذاری می‌شوند.',
        },
      },
    ],
  },
  {
    version: '1.8.6',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Packing lists on a phone: the form, the record and the short-labels sheet are now laid out for a thumb. Buttons and arrows are larger, tapping a field no longer zooms the page in, the form ends with full-width Cancel and Save buttons, and the item table of a record fits the screen instead of being cut off.',
          ar: 'قوائم التعبئة على الهاتف: صُمّمت الآن واجهة النموذج والسجل وورقة الملصقات القصيرة للاستخدام بالإبهام. صارت الأزرار والأسهم أكبر، ولم يعد لمس أي حقل يكبّر الصفحة، وينتهي النموذج بزرّي إلغاء وحفظ بعرض كامل، ويتسع جدول البنود في السجل للشاشة بدل أن يُقطع.',
          fa: 'پکینگ لیست روی موبایل: فرم، صفحهٔ رکورد و برگهٔ برچسب‌های کوتاه اکنون برای انگشت شست چیده شده‌اند. دکمه‌ها و فلش‌ها بزرگ‌تر شدند، لمس یک فیلد دیگر صفحه را بزرگ نمی‌کند، پایین فرم دکمه‌های تمام‌عرض انصراف و ذخیره دارد و جدول اقلام رکورد به‌جای بریده‌شدن در عرض صفحه جا می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Packing list form: typing in a pallet, and moving pallets, is much faster on long lists. Only the pallet you are changing is redrawn, so a list of 30 or more pallets no longer makes a phone wait after every key.',
          ar: 'نموذج قائمة التعبئة: صارت الكتابة في الطبلية ونقل الطبليات أسرع بكثير في القوائم الطويلة. فلا تُعاد رسم سوى الطبلية التي تغيّرها، ولم تعد قائمة من 30 طبلية أو أكثر تجعل الهاتف ينتظر بعد كل حرف.',
          fa: 'فرم پکینگ لیست: تایپ در یک پالت و جابه‌جایی پالت‌ها در لیست‌های بلند بسیار سریع‌تر شد. فقط پالتی که تغییر می‌دهید دوباره رسم می‌شود، پس در لیست ۳۰ پالتی یا بیشتر موبایل دیگر بعد از هر حرف منتظر نمی‌ماند.',
        },
      },
    ],
  },
  {
    version: '1.8.5',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Packing list form: pallets now move smoothly. A pallet you move slides to its new place, the pallet numbers roll to their new values, and a pallet you add or duplicate eases in while one you remove folds away. (Nothing moves if your device is set to reduce motion.)',
          ar: 'نموذج قائمة التعبئة: صارت حركة الطبليات انسيابية. فالطبلية التي تنقلها تنزلق إلى مكانها الجديد، وتتغير أرقام الطبليات بحركة ناعمة، والطبلية التي تضيفها أو تكرّرها تظهر بسلاسة، وتلك التي تحذفها تنطوي وتختفي. (ولا تتحرك العناصر إذا كان جهازك مضبوطًا على تقليل الحركة.)',
          fa: 'فرم پکینگ لیست: جابه‌جایی پالت‌ها اکنون روان است. پالتی که جابه‌جا می‌کنید به جای تازهٔ خود می‌لغزد، شمارهٔ پالت‌ها با حرکتی نرم عوض می‌شود، پالتی که اضافه یا کپی می‌کنید نرم ظاهر می‌شود و پالتی که حذف می‌کنید جمع می‌شود و از بین می‌رود. (اگر دستگاه شما روی کاهش حرکت تنظیم شده باشد، چیزی حرکت نمی‌کند.)',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Short labels sheet: the labels now always print on one side of the A4 page. (The \u201cBack to back\u201d option was removed.)',
          ar: 'ورقة الملصقات القصيرة: تُطبع الملصقات الآن دائمًا على وجه واحد من ورقة A4. (أُزيل خيار \u00abظهرًا لظهر\u00bb.)',
          fa: 'برگهٔ برچسب‌های کوتاه: برچسب‌ها اکنون همیشه روی یک طرف برگ A4 چاپ می‌شوند. (گزینهٔ \u00abپشت و رو\u00bb حذف شد.)',
        },
      },
    ],
  },
  {
    version: '1.8.4',
    date: '2026-10-21',
    changes: [
      {
        type: 'improved',
        text: {
          en: 'Printed invoices, quotations and packing lists are easier to read: larger, darker type and clearer lines. A document that runs onto more pages now continues complete — no row is cut in half — with its header repeated at the top of every page.',
          ar: 'الفواتير وعروض الأسعار وقوائم التعبئة المطبوعة أسهل قراءة: خط أكبر وأغمق وخطوط أوضح. وإذا امتد المستند إلى صفحات إضافية فإنه يُكمَل كاملًا — دون قطع أي صف إلى نصفين — مع تكرار الترويسة أعلى كل صفحة.',
          fa: 'فاکتورها، پیش‌فاکتورها و پکینگ لیست‌های چاپی خواناتر شدند: حروف درشت‌تر و پررنگ‌تر و خطوط واضح‌تر. اگر سند به چند صفحه برسد کامل ادامه پیدا می‌کند — هیچ ردیفی نصف نمی‌شود — و سربرگ در بالای هر صفحه تکرار می‌شود.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The printed packing list no longer includes the per-pallet summary table — only the detailed list. Nothing was removed from the form or the saved data.',
          ar: 'لم يعد جدول ملخص الطبليات يظهر في طباعة قائمة التعبئة، ويبقى جدول التفاصيل فقط. ولم يُحذف شيء من النموذج أو من البيانات المحفوظة.',
          fa: 'جدول خلاصهٔ پالت‌ها دیگر در چاپ پکینگ لیست نمی‌آید و فقط جدول جزئیات می‌ماند. چیزی از فرم یا داده‌های ذخیره‌شده حذف نشده است.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Short pallet labels: print up to 5 on one A4 sheet. Pick the pallets, and switch on “Back to back” to print the same labels on both sides of the sheet.',
          ar: 'ملصقات الطبليات القصيرة: اطبع حتى 5 ملصقات على ورقة A4 واحدة. اختر الطبليات، وفعّل «ظهرًا لظهر» لطباعة الملصقات نفسها على وجهي الورقة.',
          fa: 'برچسب پالت کوتاه: تا 5 برچسب را روی یک برگ A4 چاپ کنید. پالت‌ها را انتخاب کنید و با گزینهٔ «پشت و رو» همین برچسب‌ها را در دو طرف برگه چاپ کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list: add the stone name — one or more — by picking it from Inventory or just typing it. It is printed on the list.',
          ar: 'قائمة التعبئة: أضف اسم الحجر — اسمًا واحدًا أو أكثر — باختياره من المخزون أو بكتابته مباشرة. ويُطبع في القائمة.',
          fa: 'پکینگ لیست: نام سنگ را — یک نام یا چند نام — از انبار انتخاب کنید یا مستقیم بنویسید. در لیست چاپ می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing list form: the pallets are numbered, and you can change their order with the arrows or by typing a number. The printed list follows the same order.',
          ar: 'نموذج قائمة التعبئة: الطبليات مرقّمة، ويمكنك تغيير ترتيبها بالسهمين أو بكتابة رقم. وتتبع القائمة المطبوعة الترتيب نفسه.',
          fa: 'فرم پکینگ لیست: پالت‌ها شماره دارند و ترتیبشان را می‌توانید با فلش‌ها یا نوشتن یک عدد تغییر دهید. لیست چاپی همان ترتیب را دنبال می‌کند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'A packing list now has the copy-link button like the other sections. (Invoices and quotations already had theirs.)',
          ar: 'أصبح لقائمة التعبئة زر نسخ الرابط مثل بقية الأقسام. (والفواتير وعروض الأسعار لديها هذا الزر أصلًا.)',
          fa: 'پکینگ لیست هم مثل بخش‌های دیگر دکمهٔ کپی پیوند دارد. (فاکتورها و پیش‌فاکتورها از قبل داشتند.)',
        },
      },
    ],
  },
  {
    version: '1.8.3',
    date: '2026-10-20',
    changes: [
      {
        type: 'new',
        text: {
          en: 'New customer: start with a phone number OR any other way to reach them — WhatsApp, e-mail, Telegram or Instagram. The same duplicate check runs on whichever you enter first, so nobody is added twice.',
          ar: 'عميل جديد: ابدأ برقم الهاتف أو بأي وسيلة تواصل أخرى — واتساب أو البريد الإلكتروني أو تيليغرام أو إنستغرام. ويُجرى فحص التكرار نفسه على ما تُدخله أولًا، فلا يُضاف أحد مرتين.',
          fa: 'مشتری جدید: با شماره تلفن یا هر راه ارتباطی دیگر شروع کنید — واتساپ، ایمیل، تلگرام یا اینستاگرام. همان بررسی تکراری‌بودن روی اولین موردی که وارد می‌کنید انجام می‌شود تا کسی دوبار ثبت نشود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Every customer now has a type — Cash customer or Regular customer — right after the contact details, with the status beside it. A cash customer is always Won. The customer list can be filtered by type.',
          ar: 'لكل عميل الآن نوع — عميل نقدي أو عميل دائم — بعد بيانات التواصل مباشرة وبجانبه الحالة. حالة العميل النقدي دائمًا «مكتمل». ويمكن تصفية قائمة العملاء حسب النوع.',
          fa: 'هر مشتری اکنون یک نوع دارد — مشتری نقدی یا مشتری دائمی — درست بعد از اطلاعات تماس و وضعیت کنار آن. وضعیت مشتری نقدی همیشه «موفق» است. فهرست مشتریان را می‌توان بر اساس نوع فیلتر کرد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Sales report: one customer purchase can hold several kinds of stone, each with its own quantity and price (Add another stone). The order total adds them up and the printed sheet groups them under the customer. Reports filed before still open and print as they were.',
          ar: 'تقرير المندوب: يمكن أن يضم شراء العميل الواحد عدة أنواع من الرخام، لكل نوع كميته وسعره (إضافة نوع رخام آخر). ويجمع إجمالي الطلب الأنواع وتجمعها الورقة المطبوعة تحت العميل. والتقارير المرفوعة سابقًا تُفتح وتُطبع كما كانت.',
          fa: 'گزارش فروشنده: یک خرید مشتری می‌تواند چند نوع سنگ داشته باشد، هر کدام با مقدار و قیمت خودش (افزودن سنگ دیگر). جمع سفارش آن‌ها را جمع می‌زند و برگهٔ چاپی آن‌ها را زیر نام مشتری گروه‌بندی می‌کند. گزارش‌هایی که قبلاً ثبت شده‌اند مثل قبل باز و چاپ می‌شوند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Every stone tied to a customer in a daily report (confirmed or lost orders, customer requests) is added to that customer’s interested products when the report is filed.',
          ar: 'كل صنف يُربط بعميل في التقرير اليومي (الطلبات المؤكدة أو غير المتفق عليها أو طلبات العملاء) يُضاف إلى الأصناف المهتم بها لدى هذا العميل عند رفع التقرير.',
          fa: 'هر سنگی که در گزارش روزانه به مشتری وصل شود (سفارش قطعی، سفارش منتفی یا درخواست مشتری) هنگام ثبت گزارش به محصولات موردعلاقهٔ آن مشتری اضافه می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.2',
    date: '2026-10-20',
    changes: [
      {
        type: 'fixed',
        text: {
          en: 'Pallet labels now print at the real label size, A5 (148 × 210 mm), with large clear type like the sample: the header with the logo and both addresses, the pallet ID over its reference, the cuts in tall rows and the total. A pallet with many cuts continues on a second page instead of shrinking until it cannot be read.',
          ar: 'تُطبع ملصقات الطبليات الآن بحجمها الحقيقي A5 (148 × 210 مم) وبخط كبير وواضح كما في النموذج: الترويسة بالشعار والعنوانين، ورقم الطبلية فوق مرجعها، والقطع في صفوف عالية ثم الإجمالي. والطبلية ذات القطع الكثيرة تستمر في صفحة ثانية بدل أن يصغر الخط حتى يتعذر قراءته.',
          fa: 'برچسب پالت‌ها اکنون با اندازهٔ واقعی A5 (148 × 210 میلی‌متر) و با خط درشت و خوانا مانند نمونه چاپ می‌شود: سربرگ با لوگو و هر دو نشانی، شناسهٔ پالت بالای رفرنس آن، قطعه‌ها در ردیف‌های بلند و جمع. پالتی که قطعه‌های زیادی دارد به‌جای ریز شدن تا حد ناخوانایی، در صفحهٔ دوم ادامه می‌یابد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Customer forms: the city is now one select for every country, with each city’s province shown next to it — there is no separate province field. Type to search by city or by province. City and province names come from GeoNames (geonames.org), CC BY 4.0.',
          ar: 'نماذج العملاء: المدينة الآن قائمة اختيار واحدة لكل دولة، وتظهر محافظة كل مدينة بجانبها — ولا يوجد حقل منفصل للمحافظة. اكتب للبحث باسم المدينة أو المحافظة. أسماء المدن والمحافظات من GeoNames (geonames.org) برخصة CC BY 4.0.',
          fa: 'فرم مشتری: شهر اکنون برای هر کشور یک انتخابگر است و استان هر شهر کنار آن نشان داده می‌شود — فیلد جداگانه‌ای برای استان وجود ندارد. برای جست‌وجو نام شهر یا استان را بنویسید. نام شهرها و استان‌ها از GeoNames (geonames.org) با مجوز CC BY 4.0 است.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists: every pallet needs its own ID and its own reference. Two pallets with the same reference (or ID) turn red and the list cannot be saved until it is fixed; the server refuses it too. A packing list number that is already used is flagged as you type.',
          ar: 'قوائم التعبئة: لكل طبلية رقمها ومرجعها الخاصان. إذا تشابه مرجع طبليتين (أو رقماهما) تتحول الحقول إلى الأحمر ولا يمكن حفظ القائمة حتى يُصحَّح ذلك، كما يرفضها الخادم. ويُنبَّه إلى رقم قائمة التعبئة المستخدم بالفعل أثناء الكتابة.',
          fa: 'پکینگ لیست: هر پالت باید شناسه و رفرنس خودش را داشته باشد. دو پالت با رفرنس (یا شناسهٔ) یکسان قرمز می‌شوند و تا اصلاح نشود لیست ذخیره نمی‌شود؛ سرور هم آن را نمی‌پذیرد. شمارهٔ پکینگ لیستی که قبلاً استفاده شده، هنگام تایپ علامت می‌خورد.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'The notes written on a packing list now appear on its printed page, and its coloured table headers print even when the browser’s “Background graphics” option is off.',
          ar: 'تظهر الآن ملاحظات قائمة التعبئة في صفحتها المطبوعة، كما تُطبع رؤوس جداولها الملونة حتى لو كان خيار «رسوم الخلفية» في المتصفح معطّلًا.',
          fa: 'یادداشت‌های نوشته‌شده روی پکینگ لیست اکنون در صفحهٔ چاپی آن دیده می‌شود و سربرگ‌های رنگی جدول‌هایش حتی وقتی گزینهٔ «Background graphics» مرورگر خاموش است چاپ می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.1',
    date: '2026-10-18',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Packing lists: the number is filled in automatically and you can change it — type your own on a new list, or renumber an existing one. A number cannot be used twice in a branch, and the automatic numbers carry on after the highest one you typed.',
          ar: 'قوائم التعبئة: يُعبأ الرقم تلقائيًا ويمكنك تغييره — اكتب رقمك الخاص في قائمة جديدة أو أعد ترقيم قائمة موجودة. لا يمكن استخدام الرقم مرتين في الفرع الواحد، وتستمر الأرقام التلقائية بعد أعلى رقم كتبته.',
          fa: 'پکینگ لیست: شماره خودکار پر می‌شود و می‌توانید آن را تغییر دهید — در لیست جدید شمارهٔ دلخواه بنویسید یا لیست موجود را شمارهٔ دیگری بدهید. یک شماره در یک شعبه دوبار استفاده نمی‌شود و شماره‌های خودکار بعد از بالاترین شمارهٔ دستی ادامه می‌یابند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The packing list number now stands out at the top of the printed packing list.',
          ar: 'يظهر رقم قائمة التعبئة الآن بوضوح أعلى قائمة التعبئة المطبوعة.',
          fa: 'شمارهٔ پکینگ لیست اکنون در بالای پکینگ لیست چاپی برجسته دیده می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.8.0',
    date: '2026-10-18',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Invoices, quotes, stock requests and packing lists keep an unsent draft while you fill them in. If the page closes or crashes, continue from the list; closing a form asks whether to keep the draft.',
          ar: 'تحتفظ الفواتير وعروض الأسعار وطلبات المخزون وقوائم التعبئة بمسودة غير مُرسلة أثناء تعبئتها. إن أُغلقت الصفحة أو تعطّلت فتابع من القائمة، وعند إغلاق النموذج يُسأل إن كنت تريد الاحتفاظ بالمسودة.',
          fa: 'فاکتورها، پیش‌فاکتورها، درخواست‌های موجودی و پکینگ لیست‌ها هنگام پر کردن، یک پیش‌نویس ارسال‌نشده نگه می‌دارند. اگر صفحه بسته شود یا خراب شود از همان فهرست ادامه دهید؛ هنگام بستن فرم هم پرسیده می‌شود که پیش‌نویس نگه داشته شود یا نه.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Pick the calendar of every invoice, quote, request and packing list — Gregorian, Shamsi (Persian) or Hijri (Arabic). The date is entered and printed in that calendar, and each branch can set its own default in People → Branches.',
          ar: 'اختر تقويم كل فاتورة وعرض سعر وطلب وقائمة تعبئة — ميلادي أو شمسي (فارسي) أو هجري (عربي). يُدخل التاريخ ويُطبع بذلك التقويم، ويمكن لكل فرع تحديد تقويمه الافتراضي من المستخدمون ← الفروع.',
          fa: 'تقویم هر فاکتور، پیش‌فاکتور، درخواست و پکینگ لیست را انتخاب کنید — میلادی، شمسی یا هجری قمری. تاریخ با همان تقویم وارد و چاپ می‌شود و هر شعبه می‌تواند تقویم پیش‌فرض خودش را در کاربران ← شعبه‌ها تعیین کند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Write any invoice or quote in dirhams, Saudi riyals, Iranian rials, US dollars or euros. Totals and the Arabic amount in words follow the currency, and each branch can set its default currency. Prices are never converted automatically.',
          ar: 'اكتب أي فاتورة أو عرض سعر بالدرهم أو الريال السعودي أو الريال الإيراني أو الدولار الأمريكي أو اليورو. تتبع الإجماليات والمبلغ كتابةً العملة، ويمكن لكل فرع تحديد عملته الافتراضية. لا تُحوَّل الأسعار تلقائيًا أبدًا.',
          fa: 'هر فاکتور یا پیش‌فاکتور را به درهم، ریال عربستان، ریال ایران، دلار آمریکا یا یورو بنویسید. جمع‌ها و مبلغ به حروف عربی با واحد پول هماهنگ می‌شوند و هر شعبه می‌تواند واحد پول پیش‌فرضش را تعیین کند. قیمت‌ها هرگز خودکار تبدیل نمی‌شوند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'External link pages: give every link its own title — for example "Contact us" for the English salesperson and «تواصل معنا» for the Arabic one. The title is the main text visitors read on the page.',
          ar: 'صفحات الروابط الخارجية: أعطِ كل رابط عنوانه الخاص — مثل «Contact us» لمندوب المبيعات الإنجليزي و«تواصل معنا» للمندوب العربي. العنوان هو النص الرئيسي الذي يقرؤه الزوار في الصفحة.',
          fa: 'صفحه‌های لینک بیرونی: برای هر لینک عنوان جداگانه بگذارید — مثلاً «Contact us» برای فروشندهٔ انگلیسی‌زبان و «تواصل معنا» برای فروشندهٔ عرب‌زبان. عنوان، متن اصلی‌ای است که بازدیدکننده‌ها در صفحه می‌خوانند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'In every form, the Up and Down arrow keys move between fields; Left and Right move too when the cursor is at the edge of the text.',
          ar: 'في كل نموذج، تنقلك مفتاحا السهم لأعلى ولأسفل بين الحقول؛ ويتنقل السهمان الأيمن والأيسر أيضًا عندما يكون المؤشر عند طرف النص.',
          fa: 'در همهٔ فرم‌ها، کلیدهای جهت بالا و پایین بین فیلدها جابه‌جا می‌شوند؛ چپ و راست هم وقتی مکان‌نما در لبهٔ متن است جابه‌جا می‌کنند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Arabic text now uses the Amiri font and Persian text uses B Nazanin, on screen and on printed documents.',
          ar: 'يستخدم النص العربي الآن خط «أميري» ويستخدم النص الفارسي خط «بي نازنين»، على الشاشة وفي المستندات المطبوعة.',
          fa: 'متن عربی اکنون با فونت «امیری» و متن فارسی با فونت «بی نازنین» نمایش داده می‌شود، هم روی صفحه و هم در اسناد چاپی.',
        },
      },
    ],
  },
  {
    version: '1.7.1',
    date: '2026-10-17',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Report & Info: edit a report you sent while it is still Open — change the text, add or remove files and voice notes — and delete reports you no longer need.',
          ar: 'الإبلاغ والمعلومات: عدّل بلاغًا أرسلته ما دام مفتوحًا — غيّر النص وأضف الملفات والمذكرات الصوتية أو أزلها — واحذف البلاغات التي لم تعد بحاجة إليها.',
          fa: 'گزارش و اطلاعات: گزارشی را که فرستاده‌اید تا وقتی «باز» است ویرایش کنید — متن را عوض کنید، فایل و پیام صوتی اضافه یا حذف کنید — و گزارش‌هایی را که دیگر لازم ندارید حذف کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'You are now notified when the status of your report changes or someone answers it, and the answer is shown on the report itself.',
          ar: 'يصلك الآن إشعار عند تغيّر حالة بلاغك أو عند الردّ عليه، ويظهر الردّ على البلاغ نفسه.',
          fa: 'اکنون وقتی وضعیت گزارش شما تغییر کند یا کسی به آن پاسخ دهد اعلان می‌گیرید و پاسخ روی خود گزارش دیده می‌شود.',
        },
      },
    ],
  },
  {
    version: '1.7.0',
    date: '2026-10-17',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Report & Info: see the app version, every section and what changed recently — and report a bug or suggest an idea with text, a voice note and files, then follow its status.',
          ar: 'الإبلاغ والمعلومات: اطّلع على إصدار التطبيق وكل الأقسام وآخر التغييرات، وأبلغ عن مشكلة أو اقترح فكرة بالنص أو بمذكرة صوتية أو بملفات، ثم تابع حالتها.',
          fa: 'گزارش و اطلاعات: نسخهٔ برنامه، همهٔ بخش‌ها و تازه‌ترین تغییرات را ببینید؛ مشکلی را گزارش دهید یا پیشنهادی بدهید (با متن، پیام صوتی و فایل) و وضعیتش را دنبال کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Digital Marketing keeps an unsent draft of your upload form. If the page closes or crashes, pick up where you left off — and a Reset button clears the form.',
          ar: 'يحتفظ التسويق الرقمي بمسودة غير مُرسلة لنموذج الرفع. إن أُغلقت الصفحة أو تعطّلت فتابع من حيث توقفت، وزر «إعادة تعيين» يمسح النموذج.',
          fa: 'بازاریابی دیجیتال از فرم بارگذاری شما یک پیش‌نویس ارسال‌نشده نگه می‌دارد. اگر صفحه بسته شود یا خراب شود، از همان‌جا ادامه دهید؛ دکمهٔ «بازنشانی» هم فرم را پاک می‌کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'When an upload is refused, the message now says why — for example, that the file is larger than the server accepts.',
          ar: 'عند رفض أي رفع، توضّح الرسالة الآن السبب — مثلًا أن الملف أكبر مما يقبله الخادم.',
          fa: 'وقتی بارگذاری رد می‌شود، پیام اکنون دلیلش را می‌گوید؛ مثلاً اینکه فایل از حدِ پذیرش سرور بزرگ‌تر است.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Pallet and stone-size fields are easier to read and type in, on phones and computers alike.',
          ar: 'أصبحت حقول المشاحنات وأبعاد الحجر أسهل في القراءة والكتابة على الهواتف وأجهزة الكمبيوتر.',
          fa: 'فیلدهای پالت و ابعاد سنگ هم روی گوشی و هم روی کامپیوتر خواناتر و راحت‌تر قابل تایپ شده‌اند.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Photos and videos now show up in Digital Marketing raw contents, and opening a draft that held a very large file no longer fails.',
          ar: 'تظهر الصور ومقاطع الفيديو الآن في المحتوى الخام بالتسويق الرقمي، ولم يعد فتح مسودة تحتوي على ملف كبير جدًا يفشل.',
          fa: 'عکس‌ها و ویدیوها اکنون در محتوای خام بازاریابی دیجیتال دیده می‌شوند و باز کردن پیش‌نویسی که فایل بسیار بزرگ دارد دیگر خطا نمی‌دهد.',
        },
      },
    ],
  },
  {
    version: '1.6.0',
    date: '2026-10-14',
    changes: [
      {
        type: 'new',
        text: {
          en: 'A daily report form for each role. Salespeople get their own sheet — customers from the CRM, stone codes from Inventory, content from Digital Marketing — saved as you type and printable in Arabic, English or Farsi.',
          ar: 'نموذج تقرير يومي لكل دور. يحصل مندوبو المبيعات على ورقتهم الخاصة — العملاء من إدارة العملاء، وأكواد الحجر من المخزون، والمحتوى من التسويق الرقمي — تُحفظ أثناء الكتابة ويمكن طباعتها بالعربية أو الإنجليزية أو الفارسية.',
          fa: 'فرم گزارش روزانه برای هر نقش. فروشندگان برگهٔ مخصوص خودشان را دارند — مشتریان از بخش مشتریان، کد سنگ از انبار، محتوا از بازاریابی دیجیتال — که هنگام تایپ ذخیره می‌شود و به فارسی، عربی یا انگلیسی قابل چاپ است.',
        },
      },
      {
        type: 'fixed',
        text: {
          en: 'Customers added without a branch are visible again in the customer list.',
          ar: 'عاد ظهور العملاء الذين أُضيفوا دون فرع في قائمة العملاء.',
          fa: 'مشتریانی که بدون شعبه اضافه شده‌اند دوباره در فهرست مشتریان دیده می‌شوند.',
        },
      },
    ],
  },
  {
    version: '1.5.0',
    date: '2026-10-07',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Website price requests become expiring offers: priced in Invoices, e-mailed to the customer, accepted on the website, and turned into an invoice.',
          ar: 'أصبحت طلبات الأسعار من الموقع عروضًا ذات مدة محدودة: تُسعَّر في الفواتير، وتُرسل بالبريد إلى العميل، ويقبلها على الموقع، وتتحول إلى فاتورة.',
          fa: 'درخواست‌های قیمت از وب‌سایت به پیشنهادهای دارای مهلت تبدیل شد: در فاکتورها قیمت‌گذاری می‌شود، با ایمیل برای مشتری می‌رود، مشتری در وب‌سایت می‌پذیرد و به فاکتور تبدیل می‌شود.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Find a stone variety by its specification — quality, size, cut and finish — in invoices, stock requests, supply and packing lists.',
          ar: 'ابحث عن صنف الحجر بمواصفاته — الجودة والمقاس والقطع والتشطيب — في الفواتير وطلبات المخزون والتوريد وقوائم التعبئة.',
          fa: 'تنوع سنگ را با مشخصاتش — کیفیت، اندازه، برش و پرداخت — در فاکتورها، درخواست‌های انبار، تأمین و لیست‌های بسته‌بندی پیدا کنید.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'The product page editor shows the real website page as you type, with a proper image gallery manager.',
          ar: 'يعرض محرر صفحة المنتج صفحة الموقع الحقيقية أثناء الكتابة، مع مدير معرض صور متكامل.',
          fa: 'ویرایشگر صفحهٔ محصول هنگام تایپ، صفحهٔ واقعی وب‌سایت را نشان می‌دهد و مدیریت گالری تصاویر هم دارد.',
        },
      },
    ],
  },
  {
    version: '1.4.0',
    date: '2026-10-03',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Branches can share their inventory with other branches (read-only) and receive stock requests.',
          ar: 'يمكن للفروع مشاركة مخزونها مع فروع أخرى (للعرض فقط) واستقبال طلبات المخزون.',
          fa: 'شعبه‌ها می‌توانند انبار خود را (فقط برای مشاهده) با شعبه‌های دیگر به اشتراک بگذارند و درخواست موجودی دریافت کنند.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Accepting a quotation now reserves the stone, and paying an invoice takes it out of stock.',
          ar: 'قبول عرض السعر يحجز الحجر الآن، ودفع الفاتورة يخرجه من المخزون.',
          fa: 'پذیرفتن پیش‌فاکتور اکنون سنگ را رزرو می‌کند و پرداخت فاکتور آن را از انبار خارج می‌کند.',
        },
      },
      {
        type: 'improved',
        text: {
          en: 'Sign in with your phone number and password.',
          ar: 'سجّل الدخول برقم هاتفك وكلمة المرور.',
          fa: 'با شماره تلفن و رمز عبور وارد شوید.',
        },
      },
    ],
  },
  {
    version: '1.3.0',
    date: '2026-09-26',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Supply: follow a stone coupe from purchase, through processing, to finished product.',
          ar: 'التوريد: تابع كتلة الحجر من الشراء، مرورًا بالمعالجة، حتى المنتج النهائي.',
          fa: 'تأمین: یک قواره سنگ را از خرید، در طول فرآوری، تا محصول نهایی دنبال کنید.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Inter-branch quotations: one branch can quote against another branch’s inventory or supply.',
          ar: 'عروض أسعار بين الفروع: يمكن لفرع أن يُسعّر من مخزون فرع آخر أو من توريده.',
          fa: 'پیش‌فاکتور بین شعبه‌ها: یک شعبه می‌تواند بر اساس انبار یا تأمین شعبهٔ دیگر پیش‌فاکتور بدهد.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Packing lists are their own section now, with printable pallet labels.',
          ar: 'أصبحت قوائم التعبئة قسمًا مستقلًا، مع ملصقات مشاحنات قابلة للطباعة.',
          fa: 'لیست‌های بسته‌بندی اکنون بخش مستقل دارند و برچسب پالت قابل چاپ هم دارند.',
        },
      },
    ],
  },
  {
    version: '1.2.0',
    date: '2026-08-28',
    changes: [
      {
        type: 'new',
        text: {
          en: 'Tutorials: short videos, images and steps for every part of the app, with a help button inside each section.',
          ar: 'الدروس التعليمية: مقاطع فيديو وصور وخطوات قصيرة لكل جزء من التطبيق، مع زر مساعدة داخل كل قسم.',
          fa: 'آموزش‌ها: ویدیو، تصویر و مراحل کوتاه برای هر بخش برنامه، با دکمهٔ راهنما در هر بخش.',
        },
      },
      {
        type: 'new',
        text: {
          en: 'Digital Marketing: link pages you can share with customers, and WhatsApp Share with messages in several languages and a history of what was sent.',
          ar: 'التسويق الرقمي: صفحات روابط يمكن مشاركتها مع العملاء، ومشاركة واتساب برسائل بعدة لغات وسجل بما أُرسل.',
          fa: 'بازاریابی دیجیتال: صفحات پیوند برای اشتراک با مشتریان، و اشتراک‌گذاری واتس‌اپ با پیام چندزبانه و تاریخچهٔ آنچه فرستاده شده.',
        },
      },
    ],
  },
  {
    version: '1.1.0',
    date: '2026-07-24',
    changes: [
      {
        type: 'new',
        text: {
          en: 'The whole app in English, Farsi and Arabic — switch language from the side menu.',
          ar: 'التطبيق كاملًا بالعربية والإنجليزية والفارسية — بدّل اللغة من القائمة الجانبية.',
          fa: 'کل برنامه به فارسی، عربی و انگلیسی — زبان را از منوی کناری عوض کنید.',
        },
      },
    ],
  },
  {
    version: '1.0.0',
    date: '2026-07-12',
    changes: [
      {
        type: 'new',
        text: {
          en: 'First release: Customers, Invoices, Inventory, Files, People and Digital Marketing.',
          ar: 'الإصدار الأول: العملاء والفواتير والمخزون والملفات والمستخدمون والتسويق الرقمي.',
          fa: 'نخستین نسخه: مشتریان، فاکتورها، انبار، فایل‌ها، کاربران و بازاریابی دیجیتال.',
        },
      },
    ],
  },
];

export const APP_VERSION = CHANGELOG[0].version;
export const APP_RELEASED = CHANGELOG[0].date;

// A change's text in the person's language, English if it was never written.
export const changeText = (change, language) => (change.text && (change.text[language] || change.text.en)) || '';
